export async function deviceHasCamera(): Promise<boolean> {
    if (!navigator.mediaDevices?.enumerateDevices) {
        return false; // very old browsers
    }

    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices.some(d => d.kind === "videoinput");
}
